export const CHECKLISTS_TARGETS = {
  CREATE_CHECKLIST: 'createChecklist',
  CHECKLISTS: 'checklists',
  CURRENT_CHECKLIST: 'currentChecklist',
  EDIT_CHECKLIST: 'editChecklist',
  DELETE_CHECKLIST: 'deleteChecklist'
};

export const CHECKLISTS_DEFAULT_STATE = {
  [CHECKLISTS_TARGETS.CREATE_CHECKLIST]: null,
  [CHECKLISTS_TARGETS.CHECKLISTS]: [],
  [CHECKLISTS_TARGETS.CURRENT_CHECKLIST]: {},
  [CHECKLISTS_TARGETS.EDIT_CHECKLIST]: null,
  [CHECKLISTS_TARGETS.DELETE_CHECKLIST]: null
};
